import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { divide } from "lodash";
import classNames from "classnames";
import {
  getPopularBrands,
  getCollectionBrands,
  getCollectionProductBrands,
  getImageBanner
} from "../../../actions/kafairAction";
import { doChangeCategory } from "../../../actions/categoryAction";

const searchCategory = id => {
  switch (id) {
    case 1:
      return "sneakers";
    case 2:
      return "apparels";
    case 9:
      return "handbags";
    case 4:
      return "lifestyles";

    default:
      return "sneakers";
  }
};

class TradingPit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sneakersOpen: false,
      apparelsOpen: false,
      handbagsOpen: false,
      localOpen: false,
      page: 1
    };
  }

  componentDidMount() {
    const payloadProducts = {
      collection: "local-brands",
      collection_type: "brands",
      page: 1,
      per_page: 16
    };

    const payloadBrands = {
      page: 1,
      per_page: 30
    };
    this.props.getImageBanner("local-brands", "local_brands");

    this.props.getCollectionProductBrands(payloadProducts, "local_brands");
    this.props.getCollectionBrands(payloadBrands, "local-brands");
  }

  toggleSneakers = () => {
    this.setState(
      {
        sneakersOpen: !this.state.sneakersOpen,
        apparelsOpen: false,
        handbagsOpen: false,
        localOpen: false
      },
      () => {
        if (this.state.sneakersOpen === true) {
          const params = {
            category: "sneakers"
          };
          this.props.getPopularBrands(params);
        }
      }
    );
  };

  toggleApparels = () => {
    this.setState(
      {
        apparelsOpen: !this.state.apparelsOpen,
        sneakersOpen: false,
        handbagsOpen: false,
        localOpen: false
      },
      () => {
        if (this.state.apparelsOpen === true) {
          const params = {
            category: "apparels"
          };
          this.props.getPopularBrands(params);
        }
      }
    );
  };

  toggleHandbags = () => {
    this.setState(
      {
        handbagsOpen: !this.state.handbagsOpen,
        sneakersOpen: false,
        apparelsOpen: false,
        localOpen: false
      },
      () => {
        if (this.state.handbagsOpen === true) {
          const params = {
            category: "handbags"
          };
          this.props.getPopularBrands(params);
        }
      }
    );
  };

  toggleLocal = () => {
    this.setState({
      localOpen: !this.state.localOpen,
      sneakersOpen: false,
      apparelsOpen: false,
      handbagsOpen: false
    });
  };

  navigateSearch(category, item) {
    const categoryName =
      category === "local-brands" ? item.category_name : category;
    const newCategory =
      categoryName === "apparels" ? "apparel" : categoryName;

    const brand_name = item.slug
      ? item.slug.toLowerCase().replace(/\-/g, "+")
      : "";

    this.props.doChangeCategory(categoryName);

    this.props.history.push({
      pathname: `/search/${newCategory}/${brand_name}`,
      search: `brands=${item.id}&pre_verified=true`
    });
  }

  renderSneakersList() {
    const { popularBrands } = this.props.data.categoryBrand;
    const category = "sneakers";

    return (
      <div className="collection-list">
        <div className="scrollable">
          {popularBrands.map((item, index) => (
            <p key={item.id} onClick={() => this.navigateSearch(category, item)}>
              {item.name}
            </p>
          ))}
        </div>
      </div>
    );
  }

  renderApparelsList() {
    const { popularBrands } = this.props.data.categoryBrand;
    const category = "apparels";

    return (
      <div className="collection-list">
        <div className="scrollable">
          {popularBrands.map((item, index) => (
            <p key={item.id} onClick={() => this.navigateSearch(category, item)}>
              {item.name}
            </p>
          ))}
        </div>
      </div>
    );
  }

  renderHandbagsList() {
    const { popularBrands } = this.props.data.categoryBrand;
    const category = "handbags";

    return (
      <div className="collection-list">
        <div className="scrollable">
          {popularBrands.map((item, index) => (
            <p key={item.id} onClick={() => this.navigateSearch(category, item)}>
              {item.name}
            </p>
          ))}
        </div>
      </div>
    );
  }

  renderLocalList() {
    const {
      localBrands: {
        brands: { data }
      }
    } = this.props;
    const category = "local-brands";

    return (
      <div className="collection-list" >
        <div className="scrollable">
          {data.map((item, index) => (
            <p key={item.id} onClick={() => this.navigateSearch(category, item)}>
              {item.name}
            </p>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <Container fluid className="trading-pit-container">
        <Row className="collection-wrapper">
          <Col>
            <p>Collections</p>
            <Row className="category-wrapper">
              <Col>
                <Row onClick={() => this.toggleSneakers()}>
                  <div className="category-button">
                    <p>SNEAKERS</p>
                    {this.state.sneakersOpen === true ? (
                      <i className="fa fa-angle-up"></i>
                    ) : (
                      <i className="fa fa-angle-down"></i>
                    )}
                  </div>
                </Row>
                <Row>
                  <div className="list-wrapper">
                    {this.state.sneakersOpen === true
                      ? this.renderSneakersList()
                      : null}
                  </div>
                </Row>
              </Col>

              <Col>
                <Row onClick={() => this.toggleApparels()}>
                  <div className="category-button">
                    <p>STREETWEAR</p>
                    {this.state.apparelsOpen === true ? (
                      <i className="fa fa-angle-up"></i>
                    ) : (
                      <i className="fa fa-angle-down"></i>
                    )}
                  </div>
                </Row>
                <Row>
                  <div className="list-wrapper">
                    {this.state.apparelsOpen === true
                      ? this.renderApparelsList()
                      : null}
                  </div>
                </Row>
              </Col>

              <Col>
                <Row onClick={() => this.toggleHandbags()}>
                  <div className="category-button">
                    <p>HANDBAGS</p>
                    {this.state.handbagsOpen === true ? (
                      <i className="fa fa-angle-up"></i>
                    ) : (
                      <i className="fa fa-angle-down"></i>
                    )}
                  </div>
                </Row>
                <Row>
                  <div className="list-wrapper">
                    {this.state.handbagsOpen === true
                      ? this.renderHandbagsList()
                      : null}
                  </div>
                </Row>
              </Col>

              <Col>
                <Row onClick={() => this.toggleLocal()}>
                  <div className="category-button">
                    <p>INDONESIAN BRANDS</p>
                    {this.state.localOpen === true ? (
                      <i className="fa fa-angle-up"></i>
                    ) : (
                      <i className="fa fa-angle-down"></i>
                    )}
                  </div>
                </Row>
                <Row>
                  <div className="list-wrapper">
                    {this.state.localOpen === true
                      ? this.renderLocalList()
                      : null}
                  </div>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dataKaFair,
  // data: state.dataKaFair.local_brands,
  localBrands: state.dataKaFair.local_brands
});

const mapDispatchToProps = dispatch => ({
  getPopularBrands: category => dispatch(getPopularBrands(category)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name)),
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
  getCollectionBrands: (payload, slug) =>
    dispatch(getCollectionBrands(payload, slug)),
  doChangeCategory: category => dispatch(doChangeCategory(category))
});

export default connect(mapStateToProps, mapDispatchToProps)(TradingPit);
